<template>
	<div class="flexcenter link button " id="button" :class="cssClass" :title="getTitle">
		<img :src="imageLeft" v-if="imageLeft" class="left" :class="this.spinIconLeft ? 'spinning' : ''" />
		<span v-if="label">{{ label }}</span>
		<img :src="imageRight" v-if="imageRight" class="right" :class="this.spinIconRight ? 'spinning' : ''" />
		<img :src="imageCenter" v-if="imageCenter" class="" :class="this.spinIconCenter ? 'spinning' : ''" />
		<b v-if="badge" style="flex-grow:1"></b>
		<div id="badge" v-if="badge" :title="getBadgeTitle">{{ badge }}</div>
	</div>
</template>


<script>
/*
Skapa en knapp med en icon på ena sidan eller i mitten. 
 <Button label='' iconCenter='button_right.png' class='warning' @click='click' :spinIconLeft="true" />

*/

export default {
	name: "Button",

	props: {
		label: String,
		title: String,
		iconLeft: String,
		iconRight: String,
		iconCenter: String,
		class: String,
		badge: String,
		badgeTitle: String,
		spinIconLeft: Boolean,
		spinIconCenter: Boolean,
		spinIconRight: Boolean
	},
	computed: {
		imageLeft() {
			if (this.iconLeft == null) {
				return null;
			}

			return require("@/assets/" + this.iconLeft);
			//return "@/assets/button_reload.png";
		},
		imageRight() {
			if (this.iconRight == null) {
				return null;
			}

			return require("@/assets/" + this.iconRight);
			//return "@/assets/button_reload.png";
		},
		imageCenter() {
			if (this.iconCenter == null) {
				return null;
			}

			return require("@/assets/" + this.iconCenter);
			//return "@/assets/button_reload.png";
		},
		cssClass() {
			if (this.class != null && this.class != "") {
				return this.class;
			}

			return "default";
		},
		getTitle() {
			if (this.title != null) {
				return this.title;
			} else {
				return this.label;
			}
		},

		getBadgeTitle() {
			if (this.badgeTitle != null) {
				return this.badgeTitle;
			} else {
				return this.label;
			}
		}
	}
};
</script>





<style scoped>
div#badge {
	background: rgba(0, 0, 0, 0.4);
	padding-left: 3px;
	padding-right: 3px;
	margin-left: 3px;
	border-radius: 5px;
	color: white;
}

div#button {
	padding: 5px;
	border-radius: 5px;
	display: inline-flex;
	font-weight: bold;
	cursor: pointer;
	margin-right: 5px;
	color: white;
	/* FP: ta bort padding med:  div#button margin-right: 0px; */
	/*background:var(--bg-message);*/
}

div#button:hover {
	background: var(--bg-message-dark);
}

.default {
	background: var(--bg-message);
	color: white;
}

.ok {
	background: var(--bg-ok);
	color: white;
}

.ok:hover {
	background: var(--bg-ok-light);
}

.warning {
	background: var(--bg-warning);
	color: white;
}

div#button.warning:hover {
	background: var(--bg-warning-dark);
}

.error {
	background: var(--bg-error);
	color: white;
}

div#button.error:hover {
	background: var(--bg-error-dark);
}

.dark {
	background: var(--dark);
	color: white;
}

.darker {
	background: var(--darker);
	color: white;
}

.base {
	background: var(--base);
}

.light {
	background: var(--light);
}

.lighter {
	background: var(--lighter);
}

.button.grey {
	background: #666666;
}

div#button.grey:hover {
	background: #4f4f4f;
}

div#button.debug:hover {
	background: var(--bg-debug-dark);
}

.debug {
	background: var(--bg-debug);
}

div img {
	height: 20px;
}

img.left {
	margin-right: 3px;
}

img.right {
	margin-left: 3px;
}
</style>
